import {
  Alert, Checkbox as MuiCheckBox,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  SelectProps,
  Button,
  Modal,
  Box,
  
  Typography,
  Dialog,
  DialogTitle,
  IconButton
} from "@mui/material";
import Grid from '@mui/material/Grid2';
import React from "react";
import { styled } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { IListaDadosNotificacoes } from "../../services/api/notificacoes/NotificacoesService";


const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

function BootstrapDialogTitle(props: DialogTitleProps) {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
}

// export interface IDadosModalNotificacoes {
//   mensagem: string;
//   titulo: string;
//   tipo: "error" | "warning" | "info" | "success";
//   codigoTipo: number;
//   visualizado: boolean;

// }
export type IModalProps = {
  dados: IListaDadosNotificacoes[] | null;
  isModalVisible: boolean;
  onBackClickClose: () => void;
}
export const DialogNotificacoes: React.FC<IModalProps> = ({ dados, onBackClickClose, isModalVisible }) => {
  const [open, setOpen] = React.useState(isModalVisible);

  if (!isModalVisible) {
    return null;
  }
  const handleClickOpen = () => {
    setOpen(true);
    onBackClickClose();
  };
  const handleClose = () => {
    setOpen(false);
    onBackClickClose();
  };

  return (

    <Box >
      <Button variant="outlined" onClick={handleClickOpen} sx={{ display: "none" }}>
        FECHAR
      </Button>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
          {dados !== null && dados.length === 1 ? "MENSAGEM" : "MENSAGENS"}
        </BootstrapDialogTitle>

        <DialogContent  dividers sx={{ minWidth: "400px" }}>
          {dados !== null && dados.sort((a, b) => Number(new Date(b.dtCriacao)) - Number(new Date(a.dtCriacao))).map((m, i) =>
          (
            m.tipo === 1 ? // "error" ?
              <Grid container spacing={1} sx={{ width: "100%", boxShadow: "4", marginBottom: "10px" }}>
                <Grid  size={{xs:12, sm:12}} sx={{ padding: "8px" }}>
                  <Alert severity="error">{m.titulo}</Alert>
                </Grid>
                <Grid  size={{xs:12, sm:12}} style={{ padding: "8px 15px" }}>
                  <Typography variant="body1">{m.mensagem}</Typography>
                </Grid>
              </Grid>
              : m.tipo === 2 ? //"warning" ?
                <Grid container spacing={1} sx={{ width: "100%", boxShadow: "4", marginBottom: "10px" }}>
                  <Grid  size={{xs:12, sm:12}} sx={{ padding: "8px" }}>
                    <Alert severity="warning">{m.titulo}</Alert>
                  </Grid>
                  <Grid  size={{xs:12, sm:12}} style={{ padding: "8px 15px" }}>
                    <Typography variant="body1">{m.mensagem}</Typography>
                  </Grid>
                </Grid>

                : m.tipo === 3 ?//"info" ?
                  <Grid container spacing={1} sx={{ width: "100%", boxShadow: "4", marginBottom: "10px" }}>
                    <Grid  size={{xs:12, sm:12}} sx={{ padding: "8px" }}>
                      <Alert severity="info">{m.titulo}</Alert>
                    </Grid>
                    <Grid  size={{xs:12, sm:12}} style={{ padding: "8px 15px" }}>
                      <Typography variant="body1">{m.mensagem}</Typography>
                    </Grid>
                  </Grid>

                  : m.tipo === 4 ? // "success" ?
                    <Grid container spacing={1} sx={{ width: "100%", boxShadow: "4", marginBottom: "10px" }}>
                      <Grid  size={{xs:12, sm:12}} sx={{ padding: "8px" }}>
                        <Alert severity="success">{m.titulo}</Alert>
                      </Grid>
                      <Grid  size={{xs:12, sm:12}} style={{ padding: "8px 15px" }}>
                        <Typography variant="body1">{m.mensagem}</Typography>
                      </Grid>
                    </Grid>
                    :
                    <Grid container spacing={1} sx={{ width: "100%", boxShadow: "4", marginBottom: "10px" }}>
                      <Grid  size={{xs:12, sm:12}} sx={{ padding: "8px" }}>
                        <Alert severity="success">{m.titulo}</Alert>
                      </Grid>
                      <Grid  size={{xs:12, sm:12}} style={{ padding: "8px 15px" }}>
                        <Typography variant="body1">{m.mensagem}</Typography>
                      </Grid>
                    </Grid>

          )
          )
          }
        </DialogContent>

        <DialogActions>
          <Button autoFocus onClick={handleClose}>
            Fechar
          </Button>
        </DialogActions>
      </BootstrapDialog>
    </Box>

  )
};